import { CommonModule } from "@angular/common";
import { Component, computed, HostListener, input } from "@angular/core";
import dayjs from "dayjs";
import { InputBaseDay } from "../calendar-base-day";

@Component({
    selector: "app-day",
    imports: [CommonModule],
    standalone: true,
    styleUrls: ["../calendar.component.scss"],
    templateUrl: "./day.component.html",
})
export class Day extends InputBaseDay {
    maxDate = input<Date | null>(null);
    minDate = input<Date | null>(null);

    @HostListener("click") click() {
        if (this.disabled()) return;

        this.store.setValue(this.day().toDate());
        this.select.emit();
    }

    disabled = computed<boolean>(() => {
        if (this.maxDateDisabled() || this.minDateDisabled()) {
            return this.maxDateDisabled() || this.minDateDisabled();
        }

        return false;
    });

    maxDateDisabled = computed<boolean>(() => {
        if (this.maxDate()) {
            return this.day().isAfter(dayjs(this.maxDate()));
        }

        return false;
    });

    minDateDisabled = computed<boolean>(() => {
        if (this.minDate()) {
            return this.day().isBefore(dayjs(this.minDate()));
        }
        return false;
    });

    backgroundColor = computed<string>(() => {
        if (this.isToday()) {
            return "today";
        }

        if (this.selected()) {
            return "selected";
        }

        return "default";
    });

    textColor = computed<string>(() => {
        if (dayjs(this.value()).get("month") !== this.day().get("month")) {
            return "prev-month";
        }

        if (this.isToday()) {
            return "today";
        }

        if (this.selected()) {
            return "selected";
        }

        if (this.day().get("day") === 0) {
            return "sunday";
        }

        if (this.day().get("day") === 6) {
            return "saturday";
        }

        return "default";
    });
}
